// Section responses can bypass the layout's server-side locale guard.
if (document.documentElement.lang === 'de') {
  const correct = (element) => {
    if (element.hasAttribute('data-language-code')) return;
    const attribute = element.matches('a') ? 'href' : element.matches('form') ? 'action' : null;
    if (!attribute) return;
    const value = element.getAttribute(attribute);
    if (!value || !/^\/en(?:\/|$)/.test(value)) return;
    element.setAttribute(attribute, value.replace(/^\/en(?=\/|$)/, '') || '/');
  };

  const correctTree = (root) => {
    if (!(root instanceof Element)) return;
    correct(root);
    root.querySelectorAll('a[href], form[action]').forEach(correct);
  };

  correctTree(document.documentElement);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') correct(record.target);
      else record.addedNodes.forEach(correctTree);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href', 'action'],
  });
}
